// extracted by mini-css-extract-plugin
module.exports = {"dialogReservationJtails":"DialogReservation_dialogReservationJtails_bP9Un"};